import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dayOfWeekField", "dayOfMonthField"]

  connect() {
    this.frequencyChanged()
  }

  frequencyChanged() {
    const select = this.element.querySelector("select[name*='frequency']")
    if (!select) return

    const frequency = select.value

    this.dayOfWeekFieldTarget.style.display = frequency === "weekly" ? "" : "none"
    this.dayOfMonthFieldTarget.style.display = frequency === "monthly" ? "" : "none"
  }
}
